import { render } from "./EditProfileForm-Component.vue?vue&type=template&id=07ca5a61"
import script from "./EditProfileForm-Component.vue?vue&type=script&lang=js"
export * from "./EditProfileForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__